import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'
import { BeneficiaryType } from 'views/TerminateContract/TerminateForm/initialValues'

interface BeneficiaryEmailFieldProps {
  index: number
}

export const BeneficiaryEmailField: React.FC<BeneficiaryEmailFieldProps> = ({
  index,
}) => {
  return (
    <Field name={`beneficiaries[${index}]email`}>
      {({ field, meta }: FieldProps<BeneficiaryType['email']>) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.email')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
        >
          <TextInput {...field} />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
